<template>
  <main class="modal-main">
    <div class="prod-popup">
      <div class="t_999 t_center fs-26">第 2 步 (共 3 步)</div>
      <div class="t_title">
        在京东APP中查看店铺名称，回到此页面输入店铺名称，点击验证店铺名称
      </div>
      <!-- <div class="t_hlep">
        如有疑问，请点击
        <span class="t_blue" @click="showCourse">如何验证</span>
      </div> -->
      <div class="step_two">
        <div class="step_img" @click="previewImg(1)">
          <img :src="step2Img1" alt="" />
        </div>
      </div>
    </div>
    <div class="verifyPart">
      <div class="subTitle">京东店铺名称</div>
      <van-field v-model="JDLink" placeholder="请在此处准确输入京东店铺名称，点击下方按钮进行验证" @blur="JDLinkBlur" />
    </div>
    <div class="tc_button">
      <div class="tc_btn back_btn shCancelBtn" @click="backStep1">返 回</div>
      <div :class="['tc_btn', JDLink.length > 0 ? 'shPrimaryBtn' : 'no_find']" @click="newCheckPasswordContent">
        验证店铺名称
      </div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc"> </preview-dialog>
  </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { JdSaleTaskApply } from '@/api/detailPage'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { Field } from 'vant'

export default {
  data() {
    return {
      step2Img1: IMG_BASE_URL + '/upaiyun/Sys/Other/5603554665471163408.png',
      step2Img2: IMG_BASE_URL + '/upaiyun/Sys/20211112/4926308343808243196.jpg',
      // 京东链接
      JDLink: '',
      previewImgSrc: '',
      previewDialogShow: false,
      // 是否免单
      isFreeCard: false,
      isCheckLoading: false
    }
  },
  components: {
    PreviewDialog,
    'van-field': Field
  },
  mounted() {
    if (this.$route.query.isFreeCard === 'true' || this.$route.query.isFreeCard === true) {
      this.isFreeCard = true
    }
    window.addEventListener('resize', this.inputFocusResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.inputFocusResize)
  },
  methods: {
    inputFocusResize() {
      // 解决问题：微信内置浏览器浏览的H5页面弹出键盘时遮盖文本框
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        window.setTimeout(() => {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    },
    // 链接输入框失去焦点
    JDLinkBlur() {
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    },
    // 步骤二 验证商品链接
    newCheckPasswordContent() {
      // 防止多次点击
      if (this.isCheckLoading) return
      if (!this.JDLink) {
        Toast('商品链接不能为空，请在上方输入商品链接')
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.isCheckLoading = true
      // 调用接口验证
      let params = {
        KeywordID: this.$route.query.keywordID,
        ShopName: this.JDLink,
        IsFreeCard: this.isFreeCard
      }
      JdSaleTaskApply(params)
        .then((res) => {
          Indicator.close()
          if (res.SaleTaskApplyInfo.IsOtherApply) {
            MessageBox({
              title: '提示',
              message: '存在一个订单未完成，请完成后再回来吧',
              showCancelButton: true,
              confirmButtonText: '去完成',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.push({
                  name: 'order',
                  query: {
                    tabIndex: 1
                  }
                })
              }
            })
            this.isCheckLoading = false
          } else {
            Toast('验证通过')
            this.readyTaskId = res.SaleTaskApplyInfo.TaskID
            this.$router.push({
              name: 'jdStepThree',
              query: {
                readyTaskId: this.readyTaskId
              }
            })
          }
        })
        .catch((res) => {
          this.isCheckLoading = false
          Indicator.close()
          if (res.ErrMsg === '商品已加入免单活动') {
            MessageBox({
              title: '提示',
              message: '商品已加入免单活动，需要免单卡才能进行兑换，是否继续购买？',
              showCancelButton: true,
              confirmButtonText: '继续购买',
              cancelButtonText: '返回',
              confirmButtonClass: 't_f23030'
            })
              .then((action) => {
                if (action === 'confirm') {
                  this.$router.push({
                    name: 'goodsDetail',
                    query: {
                      productID: this.$route.query.productId,
                      isFreeCard: true
                    }
                  })
                } else {
                  this.$router.push({
                    name: 'souhuo'
                  })
                }
              })
              .catch((res) => {})
          } else if (res.ErrMsg === '订单数据不存在') {
            MessageBox({
              title: '提示',
              message: '当前订单已过期，请重新选择商品~',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.replace({ name: 'souhuo' })
              }
            })
          } else {
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          }
        })
    },
    // 如何验证
    showCourse() {
      this.$router.push({
        name: 'courseStep',
        query: {
          indexStep: 2,
          platform: 2
        }
      })
    },
    // 预览图片
    previewImg(val) {
      if (val === 1) {
        this.previewImgSrc = this.step2Img1
      } else {
        this.previewImgSrc = this.step2Img2
      }
      this.previewDialogShow = true
    },
    // 返回第一步
    backStep1() {
      this.$router.go(-1)
    }
  },
  beforeRouteEnter(to, from, next) {
    let fromRoutes = ['jdStepOne', 'courseStep', 'jdQuestionOne', 'jdQuestionTwo', 'jdQuestionThree']
    if (fromRoutes.indexOf(from.name) !== -1) {
      next()
    } else {
      next({ name: 'souhuo' })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../step.scss';
.taobaoPas {
  margin: 20px 0;
  padding: 0 20px;
}
.taobaoPas .mint-cell-wrapper {
  font-size: 14px;
}
.modal-main {
  background-color: #f2f2f2;
}
.tc_button {
  bottom: 0;
  background-color: #fff;
  padding: 14px 0;
}
.verifyPart {
  margin-top: 12px;
  background-color: #fff;
  padding: 4%;
  box-sizing: border-box;
  font-size: 14px;
  .subTitle {
    font-size: 15px;
    font-weight: 700;
  }
  .van-cell {
    padding-left: 0;
  }
}
</style>
